import React, { useEffect, useState } from 'react';

const SnowOverlay: React.FC = () => {
  const [snowflakes, setSnowflakes] = useState<Array<{ id: number; left: number; duration: number; delay: number }>>([]);

  useEffect(() => {
    // Generate static snowflakes to avoid constant re-renders/heavy calculations
    const flakes = Array.from({ length: 50 }).map((_, i) => ({
      id: i,
      left: Math.random() * 100, // percentage
      duration: Math.random() * 5 + 5, // 5-10s
      delay: Math.random() * 5, // 0-5s
    }));
    setSnowflakes(flakes);
  }, []);

  return (
    <div className="fixed inset-0 pointer-events-none z-0 overflow-hidden" aria-hidden="true">
      {snowflakes.map((flake) => (
        <div
          key={flake.id}
          className="absolute top-[-10px] bg-white rounded-full opacity-60 animate-[fall_linear_infinite]"
          style={{
            left: `${flake.left}%`,
            width: `${Math.random() * 4 + 2}px`,
            height: `${Math.random() * 4 + 2}px`,
            animationDuration: `${flake.duration}s`,
            animationDelay: `-${flake.delay}s`,
          }}
        />
      ))}
      <style>{`
        @keyframes fall {
          0% { transform: translateY(-10px) translateX(0px); opacity: 0; }
          10% { opacity: 0.8; }
          100% { transform: translateY(100vh) translateX(20px); opacity: 0.3; }
        }
      `}</style>
    </div>
  );
};

export default SnowOverlay;